import { render, staticRenderFns } from "./HistoryRisk.vue?vue&type=template&id=19af8812&"
import script from "./HistoryRisk.vue?vue&type=script&lang=js&"
export * from "./HistoryRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports